<template>
  <div class='oversea-area'>

    <el-form-item :label="$t('COUNTRY/REGION')">
      <br />
      <v-select v-model="country" label="text" :rows="5" :options="availableCountriesList">
      </v-select>
    </el-form-item>

    <div v-show="country">
      <el-form-item :label="$t('ADDRESS_TXT_CITY')">

        <el-input type="text" v-model="city"></el-input>
      </el-form-item>
      <el-form-item :label="$t('ADDRESS_TXT_DISTICT')">
        <el-input class="address-input" type="text" v-model="area"></el-input>
      </el-form-item>

      <el-form-item :label="$t('ADDRESS_TXT_STREET')">
        <el-input class="address-input" type="text" v-model="street"></el-input>
      </el-form-item>

      <el-form-item :label="$t('ADDRESS_TXT_STREET_NUM')">
        <el-input class="address-input" type="text" v-model="streetnum"></el-input>
      </el-form-item>

      <el-form-item :label="$t('ADDRESS_TXT_BUILDING')">
        <el-input class="address-input" type="text" v-model="building"></el-input>
      </el-form-item>

      <el-form-item :label="$t('ADDRESS_TXT_POSTAL_CODE')">
        <el-input class="address-input" type="text" v-model="postalcode"></el-input>
      </el-form-item>

      <el-form-item :label="$t('FLOOR')">
        <span class="other-tips" v-show="floorType == 'OTHER'">{{
          $t("FLOOR_OTHER_HINT")
        }}</span>
        <div>
          <br v-show="floorType != 'OTHER'" />
          <el-input type="tel" :placeholder="$t('FLOOR_HINT')" v-model="localAddressFloor" class="input-select"
            :disabled="floorInputDisableFlag">
          </el-input>
          <el-select v-model="floorType" slot="append" class="type-selector" @change="selectFloorType">
            <el-option :label="$t('FLOOR_TYPE_F')" value="F"></el-option>
            <el-option :label="$t('FLOOR_TYPE_R/C')" value="R/C"></el-option>
            <el-option :label="$t('FLOOR_TYPE_OTHER')" value="OTHER"></el-option>
          </el-select>
        </div>
      </el-form-item>

      <el-form-item :label="$t('UNIT')">
        <span class="other-tips" v-show="unitType == 'OTHER'">{{
          $t("UNIT_OTHER_HINT")
        }}</span>
        <div>
          <br v-show="unitType != 'OTHER'" />
          <el-input :placeholder="$t('UNIT_HINT')" v-model="localAddressUnit" :disabled="unitInputDisableFlag"
            class="input-select">
          </el-input>
          <el-select v-model="unitType" slot="append" class="type-selector" @change="selectUnitType">
            <el-option :label="$t('UNIT_TYPE_ROOM')" value="ROOM"></el-option>
            <el-option :label="$t('UNIT_TYPE_UNIT')" value="UNIT"></el-option>
            <el-option :label="$t('UNIT_TYPE_STORE')" value="STORE"></el-option>
            <el-option :label="$t('UNIT_TYPE_OTHER')" value="OTHER"></el-option>
          </el-select>
        </div>
      </el-form-item>

      <el-form-item :label="$t('OTHER_PART')">
        <el-input style="width: 100%" :placeholder="$t('OTHER_PART_HINT')" v-model="localAddressOther"></el-input>
      </el-form-item>

    </div>


  </div>
</template>

<script>
import countries from "@/data/countries";
import { getLocale } from "@/i18n.js";
import { getLocaledFloorAndUnitStr, getFloorValue, getUnitValue } from "./floor_and_unit.js";

function toSubmit(data) {  
  if (data == '') { return null }  
  return data;
}


export default {
  data() {
    return {
      availableCountriesList: [],
      country: undefined,
      city: '',
      area: '',
      street: '',
      streetnum: '',
      building: '',
      postalcode: '',
      localAddressOther: "",
      localAddressFloor: "",
      localAddressUnit: "",
      floorType: "F",
      unitType: "ROOM",
      floorInputDisableFlag: false,
      unitInputDisableFlag: false,
      countries: countries,
    }
  },
  props: ['showIncompleteInputParent', 'showWarningParent', 'showInvalidFieldParent'],


  mounted() {
    this.genCountriesList();
  },


  watch: {
    '$i18n.locale': function (newVal, oldVal) {

      if (oldVal != newVal) {
        const countryKey = this.country?.key;
        this.genCountriesList();
        this.selectCountry(countryKey);

      }
    }
  },

  methods: {
    selectCountry(countryKey) {
      this.country = this.availableCountriesList.find(x => x.key == countryKey)
    },

    genCountriesList() {
      const lang = getLocale();

      console.log("countries:",countries.length)
      const list = countries.map((c) => {
        let name = c[lang] || c["zh"]
        if (lang == "zh") { name = name +"  "+ c["en"]}
        return { key: c.icao, text: name };
      });
      this.availableCountriesList = list.sort((a, b) => a.text.localeCompare(b.text));
    },


    selectFloorType() {
      if (this.floorType == "F") {
        this.floorInputDisableFlag = false;
      } else {
        if (this.floorType == "OTHER") {
          this.unitType = "OTHER";
          this.localAddressFloor = "";
          this.selectUnitType();
        }
        this.floorInputDisableFlag = true;
      }
    },

    selectUnitType() {
      if (this.unitType != "OTHER") {
        this.unitInputDisableFlag = false;
      } else {
        this.localAddressUnit = "";
        this.unitInputDisableFlag = true;
      }
    },

    getFloorAndUnitStr(locale) {
      const { localAddressFloor, localAddressUnit, floorType, unitType } = this;
      return getLocaledFloorAndUnitStr(locale, localAddressFloor, localAddressUnit, floorType, unitType)
    },


    getLocalAddressRemain(locale) {
      return this.getFloorAndUnitStr(locale) + this.localAddressOther;
    },

    getFullAddress() {
      return this.getEnFullAdress();
    },


    getCountryTxt() {
      const lang = getLocale();
      if (lang == 'zh') {
        return this.country.text?.split(' ').slice(1).join(' ')
      }
      return this.country.text
    },



    getEnFullAdress() {
      let address = this.getCountryTxt();

      if (this.postalcode) {
        address = this.postalcode + ', ' + address
      }

      if (this.city) {
        address = this.city + ', ' + address
      }

      if (this.area) {
        address = this.area + ', ' + address
      }

      if (this.street) {
        address = this.street + ', ' + address
      }

      if (this.streetnum) {
        address = this.streetnum + ', ' + address
      }

      if (this.building) {
        address = this.building + ', ' + address
      }

      const remain = this.getLocalAddressRemain('en');

      if (remain) {
        address = remain + ', ' + address
      }
      return address;
    },

    validForm() {
      this.localAddressUnit = this.localAddressUnit.trim();
      this.localAddressFloor = this.localAddressFloor.trim();
      
      const { country, city } = this;

      if (!country) {
        this.showIncompleteInputParent(this.$t("COUNTRY/REGION"));
        return false;
      }

      if (city === '') {
        this.showIncompleteInputParent("城市");
        return false;
      }

      let txt = this.getEnFullAdress();

      if (txt === '') {
        this.showIncompleteInputParent("");
        return false
      }

      return true;
    },

    getSubmitObject() {
      const { country } = this;
      return {
        region: toSubmit(this.city),
        country: country.key,
        area: toSubmit(this.area),
        floor: getFloorValue(this.localAddressFloor, this.floorType),
        unit: getUnitValue(this.localAddressUnit, this.unitType),
        other: toSubmit(this.localAddressOther),
        street: toSubmit(this.street),
        streetnum: toSubmit(this.streetnum),
        building: toSubmit(this.building),
        fulladdress: this.getFullAddress(),
        blang: getLocale(),
        postalcode: toSubmit(this.postalcode),
      }
    }
  }
}
</script>

<style>
.input-label {
  font-size: 12px;
  margin-bottom: 2px;
}

.oversea-area {
  min-height: 300px;
}
</style>
